import { render, staticRenderFns } from "./storage.vue?vue&type=template&id=070f2060&scoped=true"
import script from "./storage.vue?vue&type=script&lang=js"
export * from "./storage.vue?vue&type=script&lang=js"
import style0 from "./storage.vue?vue&type=style&index=0&id=070f2060&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070f2060",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('070f2060')) {
      api.createRecord('070f2060', component.options)
    } else {
      api.reload('070f2060', component.options)
    }
    module.hot.accept("./storage.vue?vue&type=template&id=070f2060&scoped=true", function () {
      api.rerender('070f2060', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workOrder/asset/storage.vue"
export default component.exports